import { createContext } from "react";

/**
 * The `DisableGroupContext` value.
 */
export interface DisableGroupContextValue {
  /**
   * Indicates whether descendent components, which are able to be disabled, should be.
   */
  readonly disabled: boolean;
}

/**
 * The `DisableGroup` context.
 */
export const DisableGroupContext = createContext<DisableGroupContextValue>({
  disabled: false,
});
